export namespace UIExternalAPI {
  export const ExternalAPIFormType = 'ycExternalApiField';
  export const EMPTY_FORM_FIELD_SOURCE = 'EMPTY_FORM_FIELD_SOURCE';

  export enum DataUpdates {
    Always = 1,
    UntilSubmitted = 2
  }
}
